import { render, staticRenderFns } from "./vnsLogPanel.vue?vue&type=template&id=68e2dca0&"
import script from "./vnsLogPanel.vue?vue&type=script&lang=js&"
export * from "./vnsLogPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports